import styled from 'styled-components';

import { IconJourneyLogoPlain } from '@components/icons/journey-logo-plain';
import { Page } from '@components/page-containers/page-container';
import { Stack } from '@components/stack';
import { theme } from '@styles/theme';

import { ContentContainer } from 'ui/preboarding-user/pages/common';

const StyledPreboardingPage = styled(Page)({
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.color.backgroundPrimary,
  overflow: 'hidden',
});

const IconContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  width: '100%',
  right: '-50%',
});

export const PreboardingPage: React.FC = ({ children }) => {
  return (
    <StyledPreboardingPage>
      <IconContainer>
        <IconJourneyLogoPlain size={640} color="uiTrans5" />
      </IconContainer>
      <ContentContainer>
        <Stack space={6} style={{ width: '100%' }}>
          {children}
        </Stack>
      </ContentContainer>
    </StyledPreboardingPage>
  );
};
